import {IntermediatePart} from "../../intermediatePart";

export default class Towel extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "towel";
    this.partName = "Towel";
    this.translateId = "visualizer.bathroom.accessories.towel";
    if (isChild) {
      this.shouldLoadInMultipleGroups = true;
    }
  }
}
